import React from 'react';
import { nf } from '~/Utils';

import ChartLabel from './ChartLabel';

const getTickLabel = (tick) => {
  if (tick >= 7000) {
    return '> 7.000';
  }
  return nf(tick);
};

const YAxis = ({ yScale }) => (
  <g>
    {yScale.ticks(5).map(tick => (
      <g key={tick} transform={`translate(0, ${yScale(tick)})`} textAnchor="middle">
        <ChartLabel dy="3">{getTickLabel(tick)}</ChartLabel>
      </g>
    ))}
  </g>
);

export default YAxis;
